import { createSlice } from '@reduxjs/toolkit';
import { ArticleCategory, Nullable } from '../../types';
import { Paginated } from '../../services/api-handlers/pagination';
import { takeEvery } from '../../helpers/store';
import { getAllArticleCategories, listArticleCategories } from '../thunks/article-category-thunks';
import { ReducerState } from '../configure-store';

export interface ArticleCategoryState extends ReducerState {
    data: Paginated<ArticleCategory>;
    current: Nullable<ArticleCategory>;
}

const initialState: ArticleCategoryState = {
    error: '',
    loading: 'none',
    requestIds: [],
    current: null,
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
};

const slice = createSlice({
    name: 'article-category',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(listArticleCategories.pending, takeEvery.pendingActionCase)
            .addCase(listArticleCategories.rejected, takeEvery.rejectedActionCase)
            .addCase(listArticleCategories.fulfilled, (state, action) => {
                takeEvery.fulfilledActionCase(state, action);
                state.data = action.payload;
            })

            .addCase(getAllArticleCategories.pending, takeEvery.pendingActionCase)
            .addCase(getAllArticleCategories.rejected, takeEvery.rejectedActionCase)
            .addCase(getAllArticleCategories.fulfilled, takeEvery.fulfilledActionCase);
    },
});

export const {} = slice.actions;

export default slice.reducer;
